const styles = (theme) => ({
  root: {
    cursor: "none !important",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "3rem",

    [theme.breakpoints.down(theme.breakpoints.values.xs + 450)]: {
      margin: "0",
    },
  },
  unChecked: {
    cursor: "none !important",
    border: "2px solid white",
    opacity: 0.5,
    borderRadius: "50%",
    width: "24px",
    height: "24px",
  },
  checked: {
    cursor: "none !important",
    border: "2px solid white",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  inner: {
    cursor: "none !important",
    width: "12px",
    height: "12px",
    backgroundColor: "#FFC636",
    borderRadius: "50%",
  },
  content: {
    cursor: "none !important",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: ".5rem",
  },
  p: {
    cursor: "none !important",
    fontFamily: "Montserrat",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "21px",
    letterSpacing: "0.02em",
    color: "white",
    opacity: 0.5,
    transition: "all 0.3s",
    margin: 0,
    width: "100%",
  },
  active: {
    cursor: "none !important",
    opacity: "1 !important",
  },
  smallDimension: {
    cursor: "none !important",
    background: "rgba(255,255,255, 0.5)",
    border: "1px solid white",
    height: "1rem",
    width: "80px",
    opacity: 0.5,
    transition: "all 0.3s",
    marginBottom: "8px",
  },
  bigDimension: {
    cursor: "none !important",
    background: "rgba(255,255,255, 0.5)",
    border: "1px solid white",
    height: "23px",
    width: "138px",
    opacity: 0.5,
    transition: "all 0.3s",
    marginBottom: "8px",
  },
  secondaryP: {
    cursor: "none !important",
    fontFamily: "Montserrat",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "21px",
    transition: "all 0.3s",
    letterSpacing: "0.02em",
    color: "white",
    margin: 0,
    width: "100%",
    opacity: 0.5,
  },
});

export default styles;
